import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showHierarchy: {
		id: 'issue-table-group-by-dropdown.group-by-label',
		defaultMessage: 'Show hierarchy',
		description: 'Text shown in the label for toggle to enable/disable the hierarchy view',
	},
});
